// @flow
import type { ComponentType } from 'react';
import React from 'react';
import { connect } from 'react-redux';

import Button from '../Button';
import StudentSchedulingPopup from '../StudentSchedulingPopup';
import Popup from '../Popup';
import styles from './passenger.css';
import * as popupActions from '../../actions/closeable';
import * as studentActions from '../../actions/students';


type PassengerPropTypes = {
  firstName: string,
  lastName: string,
  pictureURL?: string,
  id: number,
  isSelected?: boolean,
  Icon?: ComponentType<*>,
  size?: string,
  onClick?: Function,
  open?: Function,
  selectStudent?: Function
};

const DummyPassenger = ({
  id,
  firstName = '',
  lastName = '',
  pictureURL,
  isSelected = false,
  Icon,
  open,
  selectStudent,
  size = 'medium',
  onClick,
}: PassengerPropTypes) => (
  <div
    className={
      `
        ${styles.passenger}
        ${styles[size]}
        ${isSelected ? styles.isSelected : ''}
      `
    }
    onClick={onClick}
    role="presentation"
  >
    <Popup
      id={`routesCalendar${id}`}
      theme="main"
      transitionType="slideDown"
      transitionMs={600}
    >
      <StudentSchedulingPopup studentId={id} />
    </Popup>
    {
     typeof pictureURL !== 'undefined'
      && (
        <div className={styles.pictureContainer}>
          <img src={pictureURL} alt="" />
        </div>
      )
   }
    <div className={styles.name}>
      { `${firstName} ${lastName}` }
    </div>
    {
      typeof Icon !== 'undefined'
        && (
          <Button
            size="small"
            onClick={() => {
              if (open) { open(`routesCalendar${id}`); }
              if (selectStudent) { selectStudent(id); }
            }}
            tint="mediumGray"
            isOutlined
            isTransparent
            clearMargins
            Icon={Icon}
            role="presentation"
          />
        )
    }
  </div>
);


export default connect(
  undefined,
  dispatch => ({
    open: (id: string) => dispatch(popupActions.open(id)),
    selectStudent: (id: number) => dispatch(studentActions.selectStudent(id)),
  }),
)(DummyPassenger);



// WEBPACK FOOTER //
// ./src/scripts/components/Passenger/index.js